import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { default as ReactLoadable } from 'react-loadable';
import hoistNonReactStatics from 'hoist-non-react-statics';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import { AuthError, FetchError, UnauthorizedError } from '@signal/utils/errors';
import { captureException, LEVELS, TAGS } from '@signal/utils/errorReporting';
import createReducerHelpers from '@signal/core/createReducerHelpers';
import createSagaHelpers from '@signal/utils/createSagaHelpers';
import isObjectLiteral from '@signal/utils/isObjectLiteral';
import renderIf from '@signal/utils/renderIf';
import Suspense from '@signal/utils/Suspense';
import withStore from '../withStore';
import withAuth from '../withAuth';
import LoadableContext from './context';
/**
 * Loadable HoC
 *
 * The interface for the Loadable higher-order component is largely the same as
 * the `react-loadable` interface. The difference is that it has added support
 * for loading data before the component is rendered.
 *
 * In addition to properties supported by `react-loadable`, it also supports:

 * @param {function} dataLoader - A function returning a promise that loads your
 * loader module. The loader module's default export should be a function that
 * accepts the loader interface and returns a promise. Example
 *   - () => import('./loader')
 *   - You can also pass it an object of these types of functions.
 *     {
 *       userInfo: () => import('containers/UserInfo/loader'),
 *       otherLoader: () => import('@signal/core/other/loader')
 *     }
 *   - When using with an object, you'll also need to pass a `loadData()` function.
 * @param {function} loadData - A function to customize the loading of data by
 * @param {function} getLoaderName - If you need to override the loader based on A/B tests, provide callback here
 * @param {function} getSkeletonName - If you need to override the skeleton based on A/B tests, provide callback here
 * giving access to the dataLoader modules and loaderInterface.
 *   - Receives `loaded` which is the resolved value(s) of `dataLoader()` and
 *     `loaderInterface` which is the loader interface which includes component
 *     props, `injectReducer`, `injectSaga`, and `ejectSaga`.
 */

export default function Loadable(_ref) {
  var dataLoader = _ref.dataLoader,
      getLoaderName = _ref.getLoaderName,
      getLoadingName = _ref.getLoadingName,
      ErrorComponent = _ref.error,
      canLoad = _ref.canLoad,
      loadData = _ref.loadData,
      _render = _ref.render,
      wrapSuspense = _ref.wrapSuspense,
      rest = _objectWithoutProperties(_ref, ["dataLoader", "getLoaderName", "getLoadingName", "error", "canLoad", "loadData", "render", "wrapSuspense"]);

  var hasDataLoader = !!dataLoader; // ensure using proper loader/loading components for A/B testing

  var loaderName = getLoaderName ? getLoaderName() : 'loader';
  var loadingName = getLoadingName ? getLoadingName() : 'loading';
  var loader = rest[loaderName];
  var Loading = rest[loadingName];
  var LoadableComponent = ReactLoadable(_objectSpread(_objectSpread({}, rest), {}, {
    loader: loader,
    loading: Loading,
    render: function render(loaded, _ref2) {
      var shouldRender = _ref2.shouldRender,
          hasError = _ref2.hasError,
          errorMessage = _ref2.errorMessage,
          retry = _ref2.retry,
          props = _objectWithoutProperties(_ref2, ["shouldRender", "hasError", "errorMessage", "retry"]);

      if (hasError && ErrorComponent) return /*#__PURE__*/React.createElement(ErrorComponent, Object.assign({
        key: "error",
        message: errorMessage,
        retry: retry
      }, props));
      if (_render) return shouldRender ? _render(loaded, props) : /*#__PURE__*/React.createElement(Loading, Object.assign({
        key: "loading"
      }, props));
      var Component = loaded.default;
      return shouldRender ? /*#__PURE__*/React.createElement(Component, Object.assign({
        key: "component"
      }, props)) : /*#__PURE__*/React.createElement(Loading, Object.assign({
        key: "loading"
      }, props));
    }
  }));

  function resolveDataLoaders() {
    return _resolveDataLoaders.apply(this, arguments);
  }

  function _resolveDataLoaders() {
    _resolveDataLoaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var loaders, loadedValues;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              loaders = mapValues(dataLoader, function (loaderFunc) {
                return loaderFunc();
              });
              loadedValues = {};
              Object.keys(loaders).forEach(function (key) {
                loaders[key].then(function (val) {
                  loadedValues[key] = val;
                });
              });
              _context2.next = 5;
              return Promise.all(map(loaders));

            case 5:
              return _context2.abrupt("return", loadedValues);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _resolveDataLoaders.apply(this, arguments);
  }

  var WrappedLoadable = /*#__PURE__*/function (_React$Component) {
    _inherits(WrappedLoadable, _React$Component);

    var _super = _createSuper(WrappedLoadable);

    function WrappedLoadable() {
      var _this;

      _classCallCheck(this, WrappedLoadable);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        store: null,
        injectReducer: null,
        injectSaga: null,
        ejectSaga: null,
        dataLoaded: !hasDataLoader,
        dataLoadInitialized: false,
        errorMessage: null
      });

      _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var injectedDependencies, _this$state, injectReducer, injectSaga, ejectSaga, shouldLoadData, loaderInterface, isComplexDataLoader, loaded, _yield$dataLoader, dataLoaderFunc, _tags2, _tags;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                injectedDependencies = _this.context;
                _this$state = _this.state, injectReducer = _this$state.injectReducer, injectSaga = _this$state.injectSaga, ejectSaga = _this$state.ejectSaga;
                shouldLoadData = _this.props.shouldLoadData;

                if (!(!hasDataLoader || !shouldLoadData)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _this.setState({
                  errorMessage: null,
                  dataLoaded: false,
                  dataLoadInitialized: true,
                  unauthorized: null
                });

                loaderInterface = {
                  props: _this.props,
                  injectedDependencies: injectedDependencies,
                  injectReducer: injectReducer,
                  injectSaga: injectSaga,
                  ejectSaga: ejectSaga
                };
                isComplexDataLoader = isObjectLiteral(dataLoader);
                _context.prev = 8;

                if (!loadData) {
                  _context.next = 24;
                  break;
                }

                if (!isComplexDataLoader) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return resolveDataLoaders(dataLoader);

              case 13:
                _context.t0 = _context.sent;
                _context.next = 19;
                break;

              case 16:
                _context.next = 18;
                return dataLoader();

              case 18:
                _context.t0 = _context.sent;

              case 19:
                loaded = _context.t0;
                _context.next = 22;
                return loadData(loaded, loaderInterface);

              case 22:
                _context.next = 32;
                break;

              case 24:
                if (!isComplexDataLoader) {
                  _context.next = 26;
                  break;
                }

                throw new Error("If you use `dataLoader` as an object, a `load()` function is required.");

              case 26:
                _context.next = 28;
                return dataLoader();

              case 28:
                _yield$dataLoader = _context.sent;
                dataLoaderFunc = _yield$dataLoader.default;
                _context.next = 32;
                return dataLoaderFunc(loaderInterface);

              case 32:
                if (_this.mounted) {
                  _this.setState(function () {
                    return {
                      dataLoaded: true
                    };
                  });
                }

                _context.next = 47;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context["catch"](8);

                if (_this.mounted) {
                  _this.setState(function () {
                    return {
                      errorMessage: _context.t1.message
                    };
                  });
                } // We don't need to report auth errors, as they are expected when session expires, etc.


                if (!(_context.t1 instanceof AuthError)) {
                  _context.next = 40;
                  break;
                }

                return _context.abrupt("return");

              case 40:
                if (!(_context.t1 instanceof UnauthorizedError)) {
                  _context.next = 43;
                  break;
                }

                _this.setState(function () {
                  return {
                    unauthorized: _context.t1
                  };
                });

                return _context.abrupt("return");

              case 43:
                if (!(_context.t1 instanceof FetchError)) {
                  _context.next = 46;
                  break;
                }

                captureException(_context.t1, {
                  level: LEVELS.ERROR,
                  tags: (_tags = {}, _defineProperty(_tags, TAGS.CATEGORY, 'Fetch Data'), _defineProperty(_tags, TAGS.COMPONENT, 'LoadableComponent'), _tags)
                });
                return _context.abrupt("return");

              case 46:
                captureException(_context.t1, {
                  level: LEVELS.FATAL,
                  tags: (_tags2 = {}, _defineProperty(_tags2, TAGS.CATEGORY, 'Data Load'), _defineProperty(_tags2, TAGS.COMPONENT, 'LoadableComponent'), _tags2)
                });

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 35]]);
      })));

      return _this;
    }

    _createClass(WrappedLoadable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
        this.loadData();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var dataLoadInitialized = this.state.dataLoadInitialized;
        if (!dataLoadInitialized) this.loadData();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            store = _this$props.store,
            rest = _objectWithoutProperties(_this$props, ["store"]);

        var _this$state2 = this.state,
            dataLoaded = _this$state2.dataLoaded,
            errorMessage = _this$state2.errorMessage,
            unauthorized = _this$state2.unauthorized; // it should only render if data is loaded and we are done transitioning

        if (unauthorized) {
          throw unauthorized;
        }

        var loadable = /*#__PURE__*/React.createElement(LoadableComponent, Object.assign({}, rest, {
          shouldRender: dataLoaded,
          hasError: !!errorMessage,
          errorMessage: errorMessage,
          retry: this.loadData
        }));
        return renderIf(wrapSuspense, /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement(Loading, null)
        }, loadable), loadable);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref4, prevState) {
        var store = _ref4.store;

        if (store !== prevState.store) {
          var _createReducerHelpers = createReducerHelpers(store),
              injectReducer = _createReducerHelpers.injectReducer;

          var _createSagaHelpers = createSagaHelpers(store),
              injectSaga = _createSagaHelpers.injectSaga,
              ejectSaga = _createSagaHelpers.ejectSaga;

          return {
            store: store,
            injectReducer: injectReducer,
            injectSaga: injectSaga,
            ejectSaga: ejectSaga
          };
        }

        return null;
      }
    }]);

    return WrappedLoadable;
  }(React.Component);

  _defineProperty(WrappedLoadable, "contextType", LoadableContext);

  _defineProperty(WrappedLoadable, "propTypes", {
    shouldLoadData: PropTypes.bool
  });

  _defineProperty(WrappedLoadable, "defaultProps", {
    shouldLoadData: true
  });

  hoistNonReactStatics(WrappedLoadable, LoadableComponent);
  return compose(withAuth(), withStore)(WrappedLoadable);
}